// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LocaleRouteImport } from './routes/$locale'
import { Route as IndexRouteImport } from './routes/index'
import { Route as StudioSplatRouteImport } from './routes/studio.$'
import { Route as LocaleIndexRouteImport } from './routes/$locale/index'
import { Route as LocalePricingRouteImport } from './routes/$locale/pricing'
import { Route as LocaleLinksRouteImport } from './routes/$locale/links'
import { Route as LocaleAboutRouteImport } from './routes/$locale/about'
import { Route as LocaleToolsRouteRouteImport } from './routes/$locale/tools/route'
import { Route as LocaleResourcesRouteRouteImport } from './routes/$locale/resources/route'
import { Route as LocaleBlogIndexRouteImport } from './routes/$locale/blog/index'
import { Route as LocaleLegalSlugRouteImport } from './routes/$locale/legal/$slug'
import { Route as LocaleBlogSlugRouteImport } from './routes/$locale/blog/$slug'
import { Route as LocaleToolsSolutionConfiguratorRouteImport } from './routes/$locale/tools/solution-configurator'
import { Route as LocaleToolsSecurityAuditAlertsRouteImport } from './routes/$locale/tools/security-audit-alerts'
import { Route as LocaleToolsPpmsAuditRouteImport } from './routes/$locale/tools/ppms-audit'
import { Route as LocaleToolsComplianceAuditRouteImport } from './routes/$locale/tools/compliance-audit'
import { Route as LocaleResourcesSlugRouteImport } from './routes/$locale/resources/$slug'
import { Route as LocaleSolutionsPropertySecurityIndexRouteImport } from './routes/$locale/solutions/property-security/index'
import { Route as LocaleSolutionsPeopleSecurityIndexRouteImport } from './routes/$locale/solutions/people-security/index'
import { Route as LocaleSolutionsPropertySecurityFeatureRouteImport } from './routes/$locale/solutions/property-security/$feature'
import { Route as LocaleSolutionsPeopleSecurityFeatureRouteImport } from './routes/$locale/solutions/people-security/$feature'
import { Route as LocaleBlogPreviewSlugRouteImport } from './routes/$locale/blog/preview.$slug'

const LocaleRoute = LocaleRouteImport.update({
            id: '/$locale',path: '/$locale',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const StudioSplatRoute = StudioSplatRouteImport.update({
            id: '/studio/$',path: '/studio/$',getParentRoute: () => rootRouteImport
          })
const LocaleIndexRoute = LocaleIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LocaleRoute
          })
const LocalePricingRoute = LocalePricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => LocaleRoute
          })
const LocaleLinksRoute = LocaleLinksRouteImport.update({
            id: '/links',path: '/links',getParentRoute: () => LocaleRoute
          })
const LocaleAboutRoute = LocaleAboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => LocaleRoute
          })
const LocaleToolsRouteRoute = LocaleToolsRouteRouteImport.update({
            id: '/tools',path: '/tools',getParentRoute: () => LocaleRoute
          })
const LocaleResourcesRouteRoute = LocaleResourcesRouteRouteImport.update({
            id: '/resources',path: '/resources',getParentRoute: () => LocaleRoute
          })
const LocaleBlogIndexRoute = LocaleBlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => LocaleRoute
          })
const LocaleLegalSlugRoute = LocaleLegalSlugRouteImport.update({
            id: '/legal/$slug',path: '/legal/$slug',getParentRoute: () => LocaleRoute
          })
const LocaleBlogSlugRoute = LocaleBlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => LocaleRoute
          })
const LocaleToolsSolutionConfiguratorRoute = LocaleToolsSolutionConfiguratorRouteImport.update({
            id: '/solution-configurator',path: '/solution-configurator',getParentRoute: () => LocaleToolsRouteRoute
          })
const LocaleToolsSecurityAuditAlertsRoute = LocaleToolsSecurityAuditAlertsRouteImport.update({
            id: '/security-audit-alerts',path: '/security-audit-alerts',getParentRoute: () => LocaleToolsRouteRoute
          })
const LocaleToolsPpmsAuditRoute = LocaleToolsPpmsAuditRouteImport.update({
            id: '/ppms-audit',path: '/ppms-audit',getParentRoute: () => LocaleToolsRouteRoute
          })
const LocaleToolsComplianceAuditRoute = LocaleToolsComplianceAuditRouteImport.update({
            id: '/compliance-audit',path: '/compliance-audit',getParentRoute: () => LocaleToolsRouteRoute
          })
const LocaleResourcesSlugRoute = LocaleResourcesSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => LocaleResourcesRouteRoute
          })
const LocaleSolutionsPropertySecurityIndexRoute = LocaleSolutionsPropertySecurityIndexRouteImport.update({
            id: '/solutions/property-security/',path: '/solutions/property-security/',getParentRoute: () => LocaleRoute
          })
const LocaleSolutionsPeopleSecurityIndexRoute = LocaleSolutionsPeopleSecurityIndexRouteImport.update({
            id: '/solutions/people-security/',path: '/solutions/people-security/',getParentRoute: () => LocaleRoute
          })
const LocaleSolutionsPropertySecurityFeatureRoute = LocaleSolutionsPropertySecurityFeatureRouteImport.update({
            id: '/solutions/property-security/$feature',path: '/solutions/property-security/$feature',getParentRoute: () => LocaleRoute
          })
const LocaleSolutionsPeopleSecurityFeatureRoute = LocaleSolutionsPeopleSecurityFeatureRouteImport.update({
            id: '/solutions/people-security/$feature',path: '/solutions/people-security/$feature',getParentRoute: () => LocaleRoute
          })
const LocaleBlogPreviewSlugRoute = LocaleBlogPreviewSlugRouteImport.update({
            id: '/blog/preview/$slug',path: '/blog/preview/$slug',getParentRoute: () => LocaleRoute
          })





const LocaleResourcesRouteRouteChildren = {
  LocaleResourcesSlugRoute: LocaleResourcesSlugRoute
}

const LocaleResourcesRouteRouteWithChildren = LocaleResourcesRouteRoute._addFileChildren(LocaleResourcesRouteRouteChildren)




const LocaleToolsRouteRouteChildren = {
  LocaleToolsComplianceAuditRoute: LocaleToolsComplianceAuditRoute,LocaleToolsPpmsAuditRoute: LocaleToolsPpmsAuditRoute,LocaleToolsSecurityAuditAlertsRoute: LocaleToolsSecurityAuditAlertsRoute,LocaleToolsSolutionConfiguratorRoute: LocaleToolsSolutionConfiguratorRoute
}

const LocaleToolsRouteRouteWithChildren = LocaleToolsRouteRoute._addFileChildren(LocaleToolsRouteRouteChildren)



const LocaleRouteChildren = {
  LocaleResourcesRouteRoute: LocaleResourcesRouteRouteWithChildren,LocaleToolsRouteRoute: LocaleToolsRouteRouteWithChildren,LocaleAboutRoute: LocaleAboutRoute,LocaleLinksRoute: LocaleLinksRoute,LocalePricingRoute: LocalePricingRoute,LocaleIndexRoute: LocaleIndexRoute,LocaleBlogSlugRoute: LocaleBlogSlugRoute,LocaleLegalSlugRoute: LocaleLegalSlugRoute,LocaleBlogIndexRoute: LocaleBlogIndexRoute,LocaleBlogPreviewSlugRoute: LocaleBlogPreviewSlugRoute,LocaleSolutionsPeopleSecurityFeatureRoute: LocaleSolutionsPeopleSecurityFeatureRoute,LocaleSolutionsPropertySecurityFeatureRoute: LocaleSolutionsPropertySecurityFeatureRoute,LocaleSolutionsPeopleSecurityIndexRoute: LocaleSolutionsPeopleSecurityIndexRoute,LocaleSolutionsPropertySecurityIndexRoute: LocaleSolutionsPropertySecurityIndexRoute
}

const LocaleRouteWithChildren = LocaleRoute._addFileChildren(LocaleRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,LocaleRoute: LocaleRouteWithChildren,StudioSplatRoute: StudioSplatRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)